import { useCallback } from 'react';

import { TooltipData } from './CursorTooltip.types';
import { useShowTooltip } from './useShowTooltip';

interface UseTooltipActionsParams {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  setTooltipData: React.Dispatch<React.SetStateAction<TooltipData>>;
  onVisibilityChange?: (isVisible: boolean) => void;
  onActiveTooltipChange?: (tooltipId: string | null) => void;
}

export const useTooltipActions = (params: UseTooltipActionsParams) => {
  const {
    isVisible,
    setIsVisible,
    setTooltipData,
    onVisibilityChange,
    onActiveTooltipChange,
  } = params;

  const hideTooltip = useCallback(() => {
    setIsVisible(false);
    onVisibilityChange?.(false);
    onActiveTooltipChange?.(null);
  }, [setIsVisible, onVisibilityChange, onActiveTooltipChange]);

  const showTooltip = useShowTooltip({
    isVisible,
    setIsVisible,
    setTooltipData,
    onVisibilityChange,
    onActiveTooltipChange,
  });

  return { hideTooltip, showTooltip };
};
